import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createReducer } from 'redux-act';
import { createSelector } from 'reselect';
import Immutable from 'seamless-immutable';
import Token from '../../data/models/Token';
import { createActions } from '../../helpers/Redux';
export var key = 'auth';

//
// Initial state
//
var initialState = {
  user: null,
  token: null,
  printToken: null
};

//
// Actions
//
export var actions = createActions(key, {
  setUser: function setUser(user) {
    return user;
  },
  setToken: function setToken(token) {
    return Token(token);
  },
  setPrintToken: function setPrintToken(printToken) {
    return printToken;
  },
  setTokenValid: function setTokenValid(valid) {
    return valid;
  },
  updateCv: function updateCv(cv, fields) {
    return {
      cv: cv,
      fields: fields
    };
  },
  updateFiles: function updateFiles(files) {
    return files;
  },
  loadMe: null,
  // Logout
  logout: null
});

//
// Reducer
//
export var reducer = createReducer(_defineProperty(_defineProperty(_defineProperty({}, actions.setUser, function (state, user) {
  return Immutable.merge(state, {
    user: user
  });
}), actions.setToken, function (state, token) {
  return Immutable.merge(state, {
    token: token
  });
}), actions.setPrintToken, function (state, printToken) {
  return Immutable.merge(state, {
    printToken: printToken
  });
}), initialState);

//
// Selectors
//
var root = function root(state) {
  return state[key];
};
var user = function user(state) {
  return root(state).user;
};
var token = function token(state) {
  return root(state).token;
};
var printToken = function printToken(state) {
  return root(state).printToken;
};
var isConnected = createSelector([user], function (value) {
  return Boolean(value == null ? void 0 : value.id);
});
export var selectors = {
  user: user,
  token: token,
  printToken: printToken,
  isConnected: isConnected
};